import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Dashboard layout breakpoints — align with assets/theme/base/breakpoints.js and SIDENAV_LAYOUT.
 */
export function useDashboardBreakpoints() {
  const theme = useTheme();
  const isMobileNav = useMediaQuery(theme.breakpoints.down("md"));
  const isCompactRail = useMediaQuery(theme.breakpoints.down("lg"));
  const isBelowLg = useMediaQuery(theme.breakpoints.down("lg"));
  const isBelowXl = useMediaQuery(theme.breakpoints.down("xl"));

  return { isMobileNav, isCompactRail, isBelowLg, isBelowXl, theme };
}
